export default {
      id: "i-vk-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "img/sprite.svg#i-vk",
      toString: function () {
        return this.url;
      }
    }